<template>
    <div :style="{height:body_height}" class="page1">
        <div style="position:absolute; top:0px; left: 8px; z-index: 99; cursor: pointer;">
          <div class="open-width">
            <button class="public-head-language" type="button" id="dropdownMenu1-login" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"
              style="
                display: flex;
                min-width: 100px;
                align-items: center;
                justify-content: space-between;
                padding-left: 15px;
                padding-right: 15px;
                text-wrap: nowrap;
              "
            >
                <p>{{languageName}}</p>
                <span class="caret open-width-caret"></span>
            </button>
            <ul class="dropdown-menu public-head-language-menu" aria-labelledby="dropdownMenu1-login">
              <li v-for="list in languages" @click="choiceLanguage($event)" v-bind:data-langcode="list.langcode" v-bind:key="list.langcode">
                <a href="javascript:void(0);">{{list.name}}</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="login-head">
            <!-- <div class="AlfredPoint01">
                <img src="../assets/image/login/AlfredPoint01.png">
            </div> -->
            <div class="AlfredPoint01">
                <img src="../assets/image/login/loggi.png" style="border-radius: 40px;height:unset;max-width:200px;">
            </div>
        </div>
        
        <div class="login-body">
            <b class="b-login">{{$t('login.LoginTitle')}}</b>

            <input class="input-username" v-model="username" :placeholder="$t('login.Username')">
            <p class="error-message" v-if="username_error">{{username_error}}</p>
            <input class="input-password" v-model="password" type="password" :placeholder="$t('login.Password')">
            <p class="error-message" v-if="password_error">{{password_error}}</p>
            <button @click="to_index">
                <b class="b-login-1">{{$t('login.Login')}}</b>
            </button>
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
import bottom from './Bottom.vue'
export default {
  name: 'Login',
  components: {bottom},
  data: function () {
    let _lang = window.config.VUE_APP_LANG_LIST.split(';').map(x => {
      return {
        name: x.split(':')[0],
        langcode: x.split(':')[1]
      }
    }).find(x => x.langcode === window.config.VUE_APP_DEFAULT_LANG)

    return {
      username: null,
      password: null,
      username_error: false,
      password_error: false,
      body_height: 'auto',
      // languages: [
      //   {name: 'English'},
      //   {name: '繁體中文'}
      // ],
      languages: window.config.VUE_APP_LANG_LIST.split(';').map(x => {
        return {
          name: x.split(':')[0],
          langcode: x.split(':')[1]
        }
      }),
      // language: 'en',
      // languageName: 'English'
      language: _lang.langcode,
      languageName: _lang.name
    }
  },
  beforeCreate () {
    // let height = document.body.clientHeight
    // console.log(height)
  },
  created () {
    // let height = document.body.clientHeight
    // console.log(height)
    // this.body_height = height;
  },
  mounted () {
    let langLS = localStorage.getItem('lang')
    let _lang = window.config.VUE_APP_LANG_LIST.split(';').map(x => {
      return {
        name: x.split(':')[0],
        langcode: x.split(':')[1]
      }
    }).find(x => x.langcode === langLS)
    if (!_lang) {
      this.$i18n.locale = window.config.VUE_APP_DEFAULT_LANG
      localStorage.setItem('lang', window.config.VUE_APP_DEFAULT_LANG)
    } else {
      this.$i18n.locale = _lang.langcode
    }
    // this.$i18n.locale = 'en'
    // let lang = this.language
    // localStorage.setItem('lang', lang)
    // functionButton.adjustsImageWhenHighlighted = NO
    // functionButton.adjustsImageWhenDisabled = NO
  },
  methods: {
    choiceLanguage (e) {
      this.languageName = e.currentTarget.firstElementChild.innerText
      this.language = e.currentTarget.getAttribute('data-langcode')
      let lang = this.language
      this.$i18n.locale = lang
      // if (lang === '繁體中文') {
      //   lang = 'zh_HK'
      //   this.$i18n.locale = 'zh'
      // } else if (lang === 'English') {
      //   this.$i18n.locale = 'en'
      // } else {
      //   this.$i18n.locale = 'en'
      // }
      localStorage.setItem('lang', lang)
    },
    to_index () {
      this.username_error = false
      this.password_error = false
      // 执行登录请求API
      const vue = this
      if (this.username == '' || this.password == '') {
        this.username_error = 'Account or password cannot be empty'
        this.password_error = 'Account or password cannot be empty'
        return false
      }
      this.axios({
        method: 'post',
        url: this.api.login,
        data: {
          username: this.username,
          password: this.password
        }
        // timeout:3000
      }).then(function (response) {
        let user = response.data
        localStorage.setItem('token', user.token)
        // 需要获取个人信息
        vue.getInfo()
        vue.$router.push({
          path: '/index'
        })
      }).catch(function (error) {
        if (error.data) {
          vue.password_error = error.data.message
          vue.username_error = error.data.message
        }
      })
    },
    getInfo () {
      this.axios({
        method: 'get',
        url: this.api.accountInfo
      }).then(function (response) {
        let locationName = response.data.siteName
        let locationNameEn = response.data.siteNameEn
        localStorage.setItem('locationName', locationName)
        localStorage.setItem('locationNameEn', locationNameEn)
      }).catch(function (error) {
        console.log(error.data)
      })
    }
  }
}
</script>

<style src="../assets/css/bootstrap.css" scoped>
</style>
<style scoped>
    .error-message {
        font-weight: 400 !important;
        font-family:'Poppins-Regular';
        padding-left: 0.4rem;
    }
    .login-body{
        width: 100%;
        height: 3.2rem;
        /*border-top: #DEEBF1 solid 1rem;*/
    }
    .login-body > input {
        width: 82.4%;
        height: 0.4rem;
        margin: auto;
        border-radius: 10px;
        border: #FFFFFF solid 1px;
        display: block;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        font-size: 0.15rem;
        color: #111;
        text-indent: 0.11rem;
    }
    .login-body > button {
        width: 82.4%;
        margin: auto;
    }

    ::-webkit-input-placeholder { /*Webkit browsers*/
        color: #AAAAAA;
        font-size: 16px;
    }

    :-moz-placeholder { /*Mozilla Firefox 4 to 8*/
        color: #AAAAAA;
        font-size: 16px;
    }

    ::moz-placeholder { /*Mozilla Firefox 19+*/
        color: #AAAAAA;
        font-size: 16px;
    }

    :-ms-input-placeholder { /*Internet Explorer 10+*/
        color: #AAAAAA;
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue